import './schedule.scss'
import LectureDetails from '../../pages/faculty/dashboard/LectureDetails'
import WeeklyCalendar from '../weekly-calendar/WeeklyCalendar'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { getFacultyDashboard } from '../../store/builders/faculty/faculty-dashboard.builder'
import { getStudentDashboard } from '../../store/builders/studentCourse/studentCourseDashboard.builder'
import { roundDownToHour } from '../../utility/genricFunction'
import { schedule } from '../../utility/constants'

function Schedule() {
  const dispatch = useDispatch()
  const { studentId, facultyId } = useSelector((state) => state.auth.user.result)
  const scheduleData = useSelector((store) => {
    if (facultyId) {
      return store.facultyDashboard.facultyDashboard
    } else if (studentId) {
      return store.studentCourse.studentDashboardData
    }
    return null
  })
  const [value, setValue] = useState(dayjs())

  useEffect(() => {
    if (studentId) {
      dispatch(
        getStudentDashboard({
          studentId,
          startDate: formatDateToUTCString(value.$d),
          endDate: formatDateToUTCString(value.$d),
        }),
      )
    } else if (facultyId) {
      dispatch(
        getFacultyDashboard({
          facultyId,
          startDate: formatDateToUTCString(value.$d),
          endDate: formatDateToUTCString(value.$d),
        }),
      )
    }
  }, [dispatch, facultyId, studentId, value])

  function formatDateToUTCString(dateObject) {
    const localDate = dayjs(dateObject)
    const year = localDate.year()
    const month = ('0' + (localDate.month() + 1)).slice(-2)
    const day = ('0' + localDate.date()).slice(-2)
    const formattedDate = `${year}-${month}-${day}T00:00:00.000Z`
    return formattedDate
  }

  return (
    <div className='schedule'>
      <div className='schedule-inner-header'>
        <h2>My schedule</h2>
        <WeeklyCalendar value={value} setValue={setValue} buttonFormat={'day'} />
      </div>

      <div className='schedule-input-fields'>
        {schedule.map((hours, index) => {
          const lecture = scheduleData?.find((data) => roundDownToHour(data?.startTime) === hours?.time)
          return (
            <div key={index} className={`schedule-div ${lecture ? 'margin-12' : 'margin-53'}`}>
              <div className='schedule-timeline'>
                <p>{hours.time}</p> <div className='separatorLine'></div>
              </div>
              {lecture && <LectureDetails lecture={lecture} />}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Schedule
